<div class="frequency-editor-compact">
  <!-- PrimeNG Accordion matching Step 2 style -->
  <p-accordion
    [multiple]="true"
    [(value)]="scheduleAccordionActiveValue"
    styleClass="compact-accordion"
  >
    <!-- Frequency Settings Accordion -->
    <p-accordionpanel value="0">
      <p-accordionheader>
        <div class="accordion-header-content">
          <i class="pi pi-sync"></i>
          <span>Frequency Settings</span>
          <span class="required-badge">Required</span>
        </div>
      </p-accordionheader>
      <p-accordioncontent>
        <div class="accordion-section-content">
          <div class="frequency-grid">
            <!-- Frequency Summary Display with Edit Button -->
            <div class="field-group span-full">
              <label class="field-label">Frequency</label>
              <div class="frequency-summary-box">
                <div class="summary-content">
                  <i class="pi pi-calendar"></i>
                  <span class="summary-text">{{ getFrequencySummary() }}</span>
                </div>
                <button
                  type="button"
                  class="edit-button"
                  (click)="editFrequency()"
                  [disabled]="disabled"
                  title="Change frequency"
                >
                  <i class="pi pi-pencil"></i>
                </button>
              </div>
            </div>

            <!-- Status Dropdown -->
            <div class="field-group">
              <label for="status" class="field-label">Status</label>
              <p-select
                inputId="status"
                [formControl]="formGroup.controls.status"
                [options]="statusOptions"
                (onChange)="onStatusChange()"
                [disabled]="disabled"
                placeholder="Select status"
                styleClass="standard-select"
                appendTo="body"
              />
            </div>

            <!-- Next Occurrence Date -->
            <div class="field-group">
              <label for="next-occurrence" class="field-label">
                Next Occurrence Date
              </label>
              <p-datepicker
                inputId="next-occurrence"
                [formControl]="formGroup.controls.nextOccurrenceUtc"
                (onSelect)="onNextOccurrenceChange($event)"
                [disabled]="disabled"
                [showIcon]="true"
                [showClear]="false"
                [readonlyInput]="true"
                [iconDisplay]="'input'"
                dateFormat="mm/dd/yy"
                placeholder="Select date"
                appendTo="body"
              />
            </div>

            <!-- Advanced Options Toggle -->
            <div class="advanced-options-toggle span-full">
              <div class="toggle-wrapper">
                <p-inputSwitch
                  [ngModel]="showAdvancedOptions"
                  (ngModelChange)="onSwitchToggle($event)"
                  [disabled]="disabled"
                />
                <label
                  class="toggle-label"
                  (click)="!disabled && onLabelClick()"
                >
                  Show Advanced Options for Date/Time and Processing
                </label>
              </div>
            </div>

            <!-- Advanced Options Section (Inside Frequency Settings) -->
            <div
              *ngIf="showAdvancedOptions"
              class="advanced-options-container span-full"
            >
              <!-- Advanced Date/Time Options -->
              <div class="advanced-section">
                <h3 class="section-title">Advanced Date/Time Options</h3>
                <div class="advanced-fields-grid">
                  <!-- Next Occurrence Time -->
                  <div class="field-group">
                    <label for="next-occurrence-time" class="field-label">
                      Next Occurrence Time ({{
                        getFormattedUtcOffset(site?.UtcOffset)
                      }})
                    </label>
                    <p-datepicker
                      inputId="next-occurrence-time"
                      [formControl]="formGroup.controls.nextOccurrenceUtc"
                      (onSelect)="onNextOccurrenceChange($event)"
                      [disabled]="disabled || !advancedOptionsAllowed"
                      [timeOnly]="true"
                      [showIcon]="true"
                      [showClear]="false"
                      [readonlyInput]="true"
                      [iconDisplay]="'input'"
                      placeholder="Select time"
                      appendTo="body"
                    />
                  </div>

                  <!-- Customer Timezone -->
                  <div class="field-group">
                    <label for="timezone" class="field-label"
                      >Customer Timezone</label
                    >
                    <p-select
                      inputId="timezone"
                      [formControl]="formGroup.controls.utcOffset"
                      [options]="timezoneOptions"
                      (onChange)="onTimezoneOffsetChange()"
                      [disabled]="disabled || !advancedOptionsAllowed"
                      placeholder="Select timezone"
                      styleClass="standard-select"
                      appendTo="body"
                    />
                    <small class="help-text">
                      Timezone that the Customer will see for Date/Time, Next
                      Occurrence, and Processing
                    </small>
                  </div>
                </div>

                <!-- Customer's Next Occurrence Date/Time Display (matches old QMC lines 214-217) -->
                <div
                  class="highlight-section"
                  *ngIf="
                    getCustomerNextOccurrence() &&
                    formGroup.controls.utcOffset.value !== undefined &&
                    formGroup.controls.utcOffset.value !== site?.UtcOffset
                  "
                >
                  <h4>Customer's Next Occurrence Date/Time</h4>
                  <p>
                    {{
                      getCustomerNextOccurrence()
                        | date: "MMMM dd, y 'at' hh:mm a"
                    }}
                    {{
                      getFormattedUtcOffset(formGroup.controls.utcOffset.value)
                    }}
                  </p>
                </div>
              </div>

              <!-- Advanced Processing Options -->
              <div class="advanced-section">
                <h3 class="section-title">Advanced Processing Options</h3>
                <div class="advanced-fields-grid">
                  <!-- Next Occurrence Offset -->
                  <div class="field-group">
                    <label for="offset" class="field-label">
                      Next Occurrence Offset
                    </label>
                    <p-inputNumber
                      inputId="offset"
                      [formControl]="formGroup.controls.nextOccurrenceOffset"
                      (onBlur)="onNextOccurrenceOffsetBlur()"
                      [disabled]="disabled || !advancedOptionsAllowed"
                      [min]="0"
                      [max]="365"
                      [showButtons]="true"
                      placeholder="0"
                    />
                    <small class="help-text">
                      Set a Number of Days before the Next Occurrence Date to
                      start processing this Scheduled Order
                    </small>
                  </div>

                  <!-- Cycles -->
                  <div class="field-group">
                    <label for="cycles" class="field-label">Cycles</label>
                    <p-inputNumber
                      inputId="cycles"
                      [formControl]="formGroup.controls.cycles"
                      (onBlur)="onCyclesBlur()"
                      [disabled]="disabled"
                      [min]="0"
                      [max]="999"
                      [showButtons]="true"
                      placeholder="0"
                    />
                    <small class="help-text">
                      The Number of Times the Scheduled Order has been processed
                      (0 = unlimited)
                    </small>
                  </div>
                </div>

                <!-- Scheduled Order will Process on Display (matches old QMC lines 230-233) -->
                <div
                  class="highlight-section"
                  *ngIf="
                    getProcessingTime() &&
                    formGroup.controls.nextOccurrenceOffset.value &&
                    formGroup.controls.nextOccurrenceOffset.value > 0
                  "
                >
                  <h4>Scheduled Order will Process on</h4>
                  <p>
                    {{ getProcessingTime() | date: "MMMM dd, y 'at' hh:mm a" }}
                    {{ getFormattedUtcOffset(site?.UtcOffset) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-accordioncontent>
    </p-accordionpanel>
  </p-accordion>
</div>
